import {
  PIM_BRAND_DETAIL_FIELD_KEY
} from "./chunk-RS5ET3Q3.js";
import {
  BaseModel_default
} from "./chunk-ITJMNR7M.js";
import {
  BaseItemModel_default
} from "./chunk-UPAELC5I.js";

// src/Pim/PimBrand/Model.ts
var BrandModel = class extends BaseModel_default {
  constructor(entities) {
    super(entities);
    if (entities) {
      this.items = entities._embedded.item.map((element) => {
        return new BrandItemModel(element);
      });
    }
  }
};
var BrandItemModel = class extends BaseItemModel_default {
  constructor(entity) {
    super(entity);
    this.id = null;
    this.name = null;
    this.level = null;
    this.parent_id = null;
    this.parent_name = null;
    this.published = null;
    this.created_user_name = null;
    this.modified_user_name = null;
    this.created_time = null;
    this.publish_up = null;
    this.modified_time = null;
    this.custom_fields = null;
    this.toJSON = () => {
      return {
        ...this.baseToJSON(),
        [PIM_BRAND_DETAIL_FIELD_KEY.ID]: this.id,
        [PIM_BRAND_DETAIL_FIELD_KEY.NAME]: this.name,
        [PIM_BRAND_DETAIL_FIELD_KEY.LEVEL]: this.level,
        [PIM_BRAND_DETAIL_FIELD_KEY.PARENT_ID]: this.parent_id,
        [PIM_BRAND_DETAIL_FIELD_KEY.PARENT_NAME]: this.parent_name,
        [PIM_BRAND_DETAIL_FIELD_KEY.PUBLISHED]: this.published,
        [PIM_BRAND_DETAIL_FIELD_KEY.CREATED_USER_NAME]: this.created_user_name,
        [PIM_BRAND_DETAIL_FIELD_KEY.MODIFIED_USER_NAME]: this.modified_user_name,
        [PIM_BRAND_DETAIL_FIELD_KEY.CREATED_TIME]: this.created_time,
        [PIM_BRAND_DETAIL_FIELD_KEY.PUBLISH_UP]: this.publish_up,
        [PIM_BRAND_DETAIL_FIELD_KEY.MODIFIED_TIME]: this.modified_time,
        [PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS]: this.custom_fields
      };
    };
    if (entity) {
      this.id = entity[PIM_BRAND_DETAIL_FIELD_KEY.ID] ?? "";
      this.name = entity[PIM_BRAND_DETAIL_FIELD_KEY.NAME] ?? "";
      this.level = entity[PIM_BRAND_DETAIL_FIELD_KEY.LEVEL] ?? "";
      this.parent_id = entity[PIM_BRAND_DETAIL_FIELD_KEY.PARENT_ID] ?? "";
      this.parent_name = entity[PIM_BRAND_DETAIL_FIELD_KEY.PARENT_NAME] ?? "";
      this.published = entity[PIM_BRAND_DETAIL_FIELD_KEY.PUBLISHED] ?? "";
      this.created_user_name = entity[PIM_BRAND_DETAIL_FIELD_KEY.CREATED_USER_NAME] ?? "";
      this.modified_user_name = entity[PIM_BRAND_DETAIL_FIELD_KEY.MODIFIED_USER_NAME] ?? "";
      this.created_time = entity[PIM_BRAND_DETAIL_FIELD_KEY.CREATED_TIME] ?? "";
      this.publish_up = entity[PIM_BRAND_DETAIL_FIELD_KEY.PUBLISH_UP] ?? "";
      this.modified_time = entity[PIM_BRAND_DETAIL_FIELD_KEY.MODIFIED_TIME] ?? "";
      this.custom_fields = entity[PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS] ?? "";
    }
  }
};
BrandItemModel.__transformItemToApiOfCreation = (data) => {
  let formData = new FormData();
  const excluded = [PIM_BRAND_DETAIL_FIELD_KEY.ID, PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS];
  Object.keys(PIM_BRAND_DETAIL_FIELD_KEY).forEach((index) => {
    if (!excluded.includes(PIM_BRAND_DETAIL_FIELD_KEY[index]) && data[PIM_BRAND_DETAIL_FIELD_KEY[index]]) {
      formData.append(PIM_BRAND_DETAIL_FIELD_KEY[index], data[PIM_BRAND_DETAIL_FIELD_KEY[index]]);
    }
  });
  if (data[PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS] && Object.keys(data[PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS]).length) {
    Object.keys(data[PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS]).forEach(function(key) {
      formData.append(
        [PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS] + "[" + key + "]",
        data[PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS][key]
      );
    });
  }
  return formData;
};
BrandItemModel.__transformItemToApiOfUpdation = (data) => {
  let formData = {};
  const excluded = [PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS];
  Object.keys(PIM_BRAND_DETAIL_FIELD_KEY).forEach((index) => {
    if (!excluded.includes(PIM_BRAND_DETAIL_FIELD_KEY[index]) && data[PIM_BRAND_DETAIL_FIELD_KEY[index]]) {
      formData[PIM_BRAND_DETAIL_FIELD_KEY[index]] = data[PIM_BRAND_DETAIL_FIELD_KEY[index]];
    }
  });
  if (data[PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS] && Object.keys(data[PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS]).length) {
    formData[PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS] = {};
    Object.keys(data[PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS]).forEach(function(key) {
      formData[PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS][key] = data[PIM_BRAND_DETAIL_FIELD_KEY.CUSTOM_FIELDS][key];
    });
  }
  return formData;
};

export {
  BrandModel,
  BrandItemModel
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
